var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconDiscount = function SvgIconDiscount(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1923 -1279)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M617.207,176.207l-9,9a1,1,0,0,1-1.414-1.414l9-9a1,1,0,0,1,1.414,1.414ZM619,184a3,3,0,1,1-3-3A3,3,0,0,1,619,184Zm-2,0a1,1,0,1,0-1,1A1,1,0,0,0,617,184Zm-9-5a3,3,0,1,1,3-3A3,3,0,0,1,608,179Zm0-2a1,1,0,1,0-1-1A1,1,0,0,0,608,177Z",
    transform: "translate(1323 1111)"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconDiscount, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-discount.d78b5374.svg";
export { ForwardRef as ReactComponent };